/**
 * Removes all localStorage and sessionStorage keys that were written with the legacy
 * "timestamps" namespace format (storejs plugin: __storejs_<appPrefix>_timestamps_<key>).
 * Call this on app init to reclaim space and avoid duplicate timestamp entries when
 * migrating to a single metadata key approach.
 */
const STOREJS_PREFIX = '__storejs_';
const TIMESTAMPS_NAMESPACE_MARKER = '_timestamps';

function removeLegacyKeysFromStorage(storage: Storage): void {
	for (let i = storage.length - 1; i >= 0; i--) {
		const key = storage.key(i);
		if (key && key.startsWith(STOREJS_PREFIX) && key.includes(TIMESTAMPS_NAMESPACE_MARKER)) {
			storage.removeItem(key);
		}
	}
}

export function removeLegacyTimestampNamespaceKeys(): void {
	const win = globalThis.window;
	if (typeof win === 'undefined') {
		return;
	}
	if (typeof win.localStorage !== 'undefined') {
		removeLegacyKeysFromStorage(win.localStorage);
	}
	if (typeof win.sessionStorage !== 'undefined') {
		removeLegacyKeysFromStorage(win.sessionStorage);
	}
}
